// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"728":"8b94e2cf","737":"bb85533a","796":"14ea75da"}[chunkId] + ".chunk.css";
};